export const consumeGa4AuditStream = async (response, onEvent) => {
    if (!response.ok) {
        const payload = await response.json().catch(() => null);
        const error = new Error(payload?.error?.message || 'The GA4 audit could not be started.');
        error.code = payload?.error?.code || 'OPENAI_REQUEST_FAILED';
        throw error;
    }
    if (!response.body?.getReader) throw new Error('Streaming is not supported by this browser.');

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    while (true) {
        const { value, done } = await reader.read();
        buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
        const blocks = buffer.split(/\r?\n\r?\n/);
        buffer = blocks.pop() || '';
        for (const block of blocks) {
            const event = block.split(/\r?\n/).find((line) => line.startsWith('event:'))?.slice(6).trim() || 'message';
            const data = block.split(/\r?\n/).filter((line) => line.startsWith('data:')).map((line) => line.slice(5).trim()).join('\n');
            if (!data) continue;
            let payload;
            try { payload = JSON.parse(data); } catch (_) { payload = { text: data }; }
            onEvent({ event, data: payload });
        }
        if (done) break;
    }
};

export const ga4AuditErrorMessage = (code) => ({
    GA4_NOT_CONNECTED: 'Google Analytics needs to be reconnected before this audit can run.',
    GA4_PROPERTY_NOT_FOUND: 'The configured GA4 property could not be found.',
    GA4_PERMISSION_DENIED: 'You do not have access to audit this GA4 property.',
    OPENAI_RATE_LIMIT: 'Report Assistant is busy right now. Please try the audit again shortly.',
    OPENAI_AUTH_ERROR: 'Report Assistant is not configured for GA4 audits.',
    AUDIT_CANCELLED: 'The GA4 audit was cancelled.',
})[code] || 'The GA4 audit could not be completed. Please try again.';
